export default __webpack_public_path__ + "static/media/ToggleJointsImg.f34ff03d.png";